import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { t } from "@/i18n-js/instance";
import { dropdowListInOut } from "@circle-react/components/shared/uikit/animations";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { CheckIcon } from "../RsvpIcons";
import { MenuLabel } from "./MenuLabel";
import { MenuOption } from "./MenuOption";
import "./styles.scss";

export interface RsvpRadioProps {
  full: boolean;
  isConfirmed: boolean;
  isLoading: boolean;
  setShouldShowUnrsvpConfirmation: (value: boolean) => void;
  showUnrsvpPopup: boolean;
  toggleRsvp: () => void;
}

export const RsvpRadio = ({
  isConfirmed,
  full,
  toggleRsvp,
  isLoading,
  setShouldShowUnrsvpConfirmation,
  showUnrsvpPopup,
}: RsvpRadioProps) => {
  const attendingLabel = t("events.rsvp.attending");
  const notAttendingLabel = t("events.rsvp.not_attending");

  const handleSelect = (attending: boolean) => {
    if (attending !== isConfirmed) {
      if (!attending && showUnrsvpPopup) {
        setShouldShowUnrsvpConfirmation(true);
      } else {
        toggleRsvp();
      }
    }
  };

  return (
    <div className={classNames("rsvp-radio", { "rsvp-radio--full": full })}>
      <Menu>
        {({ open }) => (
          <>
            <Menu.Button
              className={classNames(
                "rsvp-radio__button !border-primary !rounded-full",
                {
                  "rsvp-radio__button--open": open,
                },
              )}
            >
              {isConfirmed ? (
                <MenuLabel label={attendingLabel} renderIcon={<CheckIcon />} />
              ) : (
                <MenuLabel label={notAttendingLabel} />
              )}
              <span className="button-icon-container">
                <ChevronDownIcon className="button-icon" aria-hidden="true" />
              </span>
            </Menu.Button>

            <Transition as={Fragment} show={open} {...dropdowListInOut}>
              <Menu.Items static className="rsvp-radio__list">
                <MenuOption
                  key="rsvp-attending"
                  label={attendingLabel}
                  value={isConfirmed}
                  disabled={isLoading}
                  onClick={() => handleSelect(true)}
                />
                <MenuOption
                  key="rsvp-not-attending"
                  label={notAttendingLabel}
                  value={!isConfirmed}
                  disabled={isLoading}
                  onClick={() => handleSelect(false)}
                />
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </div>
  );
};
